export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "https://gop-backend-7201333562ee.herokuapp.com/api";
export const ENVIRONMENT = process.env.ENVIRONMENT || "prod";
console.log("BACKEND_URL", BACKEND_URL);
console.log("ENVIRONMENT", ENVIRONMENT);
